export default "__VITE_ASSET__rd2aifvR__"